import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./Dataroom.module.scss";

import { NormalButton } from "@/frontend/shared/ui/Button";
import { categories } from "../categories";
import { DataroomFileContainer } from "./components/DataroomFileContainer/DataroomFileContainer";
import { useState } from "react";

export function DataroomSection() {
  type Tfiles = {
    [key: string]: string[];
  };

  const [files, setFiles] = useState<Tfiles>({
    "Team Documents": ["a", "b"]
  });

  function handleFileUpload(category: string, files: string[]) {
    setFiles((prevFiles) => {
      const updatedFiles = { ...prevFiles };

      if (!updatedFiles[category]) {
        updatedFiles[category] = files;
      } else {
        updatedFiles[category] = [...updatedFiles[category], ...files];
      }

      return updatedFiles;
    });
  }

  return (
    <div className={styles.container}>
      <Typography variant="heading-6" color="greyscale900">
        Data Room
      </Typography>
      <div className={styles.categoriesContainer}>
        {categories.map((category) => (
          <DataroomFileContainer name={category} files={files[category]} handleFileUpload={handleFileUpload} />
        ))}
      </div>

      <div className={styles.bottomButtonsContainer}>
        <NormalButton size="large">Proceed</NormalButton>
        <NormalButton size="large" variant="secondary" color="greyscale800">
          Step back
        </NormalButton>
      </div>
    </div>
  );
}
